<template>
  <footer class="shell-footer">
    <v-sheet color="primary">
      <v-container
        class="
          pt-0
          pb-5
          d-flex
          flex-column flex-sm-row
          justify-center
          align-center
          text-center
        "
      >
        <a
          class="d-flex mt-5"
          href="https://www.mrxweb.com.br/"
          target="_blank"
        >
          <img
            class="shell-footer-logo"
            src="../../assets/img/mrxweb.svg"
            alt="MRX Web Sites, Publicidade, Marketing Digital, Produção de Vídeos - Sinop/MT"
            title="MRX Web Sites, Publicidade, Marketing Digital, Produção de Vídeos - Sinop/MT"
            height="20px"
          />
        </a>

        <v-sheet
          v-if="!xsOnly"
          class="mt-4 mx-4"
          color="rgba(255, 255, 255, 0.20)"
          height="26px"
          width="1px"
        ></v-sheet>

        <div class="white--text text-body-2 font-weight-regular mt-3 mt-sm-5">
          ©
          <b class="font-weight-bold">{{ informations.name }}</b>
          {{ year }}.
          <span class="d-block d-sm-inline-block">
            Todos os direitos reservados.
          </span>
        </div>
      </v-container>
    </v-sheet>
  </footer>
</template>

<script>
import { getContact } from "../../utils/getContact";
import { getSocial } from "../../utils/getSocial";

export default {
  data: () => ({
    year: new Date().getFullYear(),
  }),
  computed: {
    informations() {
      return this.$rest("informations").item;
    },
    contacts() {
      return getContact(this.informations);
    },
    social() {
      return getSocial(this.informations);
    },
    xsOnly() {
      return this.$vuetify.breakpoint.xsOnly;
    },
  },
};
</script>
